import { Box } from "@mui/system";
import { useEffect } from "react";
import { useFormValidator } from "../../../../../common/inputs/useFormValidator";
import { CountryDropdown, ValidatedTextInput } from "../../../../../common/inputs/ValidatedInputs";
import { withQueryData } from "../../../../../common/withQueryData";
import { useConfigurationData } from "../../../../../common/hooks/useConfigurationData";

const CustomerEditor = (props) => {
    const { data, handleInputChange, onChangeValid, loading } = props;

    // eslint-disable-next-line no-unused-vars
    const [valid, setValid, resetValid, fieldsValidity, formChanged, onFormChange] = useFormValidator();

    const { countriesQueryResults } = useConfigurationData();

    const onChange = (id, value, valid) => {
        const payload = {
            id: `customer.${id}`,
            value
        };

        handleInputChange([payload]) && onFormChange();
        setValid(id, valid);
    }

    useEffect(() => {
        onChangeValid && onChangeValid(valid)
    }, [onChangeValid, valid]);

    return <CustomerEditorContentWithQueryData
        queryData={countriesQueryResults}
        customerInfo={data.customer}
        onChange={onChange}
        disableError={!formChanged}
        loading={loading}
    />;
}

const CustomerEditorContent = ({ data: countries, customerInfo, onChange, disableError, loading }) => {
    const style = {
        margin: '10px 20px 10px 0px',
    }

    const selectedCountry = customerInfo.countryCode && countries.find(country => country.code === customerInfo.countryCode);
    const selectedCountryPrefix = customerInfo.countryPrefix && countries.find(country => country.phonePrefix === customerInfo.countryPrefix);

    const onChangeCountry = (id, country, valid) => {
        onChange(id, country && country.code, valid);
    }

    const onChangeCountryPrefix = (id, country, valid) => {
        onChange(id, country && country.phonePrefix, valid);
    }

    return <Box sx={{ display: 'flex', flexDirection: 'column', width: '450px' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <ValidatedTextInput
                size='small'
                id='firstName'
                onChange={onChange}
                label='First name'
                required
                sx={style}
                value={customerInfo.firstName}
                disableError={disableError}
                disabled={loading}
            />
            <ValidatedTextInput
                size='small'
                id='lastName'
                onChange={onChange}
                label='Last name'
                required
                sx={style}
                value={customerInfo.lastName}
                disableError={disableError}
                disabled={loading}
            />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <ValidatedTextInput
                size='small'
                id='email'
                onChange={onChange}
                label='Email'
                required
                sx={style}
                value={customerInfo.email}
                disableError={disableError}
                disabled={loading}
                email
            />
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <CountryDropdown
                    id='countryPrefix'
                    value={selectedCountryPrefix}
                    onChange={onChangeCountryPrefix}
                    countries={countries}
                    required
                    sx={style}
                    disableError={disableError}
                    disabled={loading}
                    textFieldProps={{
                        label: 'Prefix',
                        size: 'small',
                        sx: {
                            width: '100px'
                        }
                    }}
                    getOptionLabel={(country) => country.phonePrefix}
                    getOptionText={(country) => `${country.phonePrefix} ${country.name}`}
                    filterOptions={(countries, { inputValue }) => countries.filter(country => {
                        return country.name.toLowerCase().includes(inputValue.toLowerCase()) || country.phonePrefix.toLowerCase().includes(inputValue.toLowerCase())
                    })}
                />
                <ValidatedTextInput
                    size='small'
                    id='phoneNumber'
                    onChange={onChange}
                    label='Phone #'
                    required
                    sx={{
                        ...style,
                        flexGrow: 1
                    }}
                    value={customerInfo.phoneNumber}
                    disableError={disableError}
                    disabled={loading}
                    phoneNumber
                />
            </Box>
            <ValidatedTextInput
                size='small'
                margin="dense"
                id="address"
                label="Address"
                required
                type="text"
                multiline
                rows="2"
                onChange={onChange}
                disabled={loading}
                value={customerInfo.address}
                sx={{
                    marginRight: '20px'
                }}
                disableError={disableError}
            />
            <CountryDropdown
                id='countryCode'
                value={selectedCountry}
                onChange={onChangeCountry}
                countries={countries}
                required
                sx={style}
                disableError={disableError}
                disabled={loading}
                textFieldProps={{
                    label: 'Country',
                    size: 'small',
                }}
            />
        </Box>
    </Box>
}

const CustomerEditorContentWithQueryData = withQueryData(CustomerEditorContent)

export default CustomerEditor;